<template>
  <div class="card-padding">
    <label class="font-size-16 font-weight-500">Package Detail</label>
    <div class="row mt-1">
      <div class="col-12 col-md-5 mt-1 d-flex align-items-center">
        <atom-input
          v-model="packageItem.packageName"
          title="Package Name"
          placeholder="Full Name"
          :isAsterisk="true"
          :isError="isError"
          errorMessage="Please enter package name"
          :isDisable="!hasUpdatePermission"
        ></atom-input>
      </div>

      <div
        class="col-12 col-md-6 margin-top-36px d-flex align-items-center"
        :class="{ 'margin-bottom-22px': isError }"
      >
        <atom-switch
          v-model="packageItem.deprecated"
          title="Set Deprecated"
          color="danger"
          :isDisable="!hasUpdatePermission"
        ></atom-switch>
      </div>
    </div>

    <!-- * Start Contract Period -->
    <molecule-sub-package
      title="Contract Period"
      shortTitle="Period"
      v-model="packageItem.periods"
      :hasUpdatePermission="hasUpdatePermission"
      @addSubPackage="addSubPackage"
    ></molecule-sub-package>
    <!-- ! End Contract Period -->

    <!-- * Start Service Detail -->
    <molecule-sub-package
      title="Service Detail"
      shortTitle="Service"
      :infoIsArray="true"
      v-model="packageItem.details"
      :hasUpdatePermission="hasUpdatePermission"
      @addSubPackage="addSubPackage"
    ></molecule-sub-package>
    <!-- ! End Service Detail -->

    <!-- * Start Add-On Package -->
    <molecule-sub-package
      title="Add-On Package"
      shortTitle="Add-On"
      v-model="packageItem.options"
      :hasUpdatePermission="hasUpdatePermission"
      @addSubPackage="addSubPackage"
    ></molecule-sub-package>
    <!-- ! End Add-On Package -->
  </div>
</template>

<script>
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSwitch from "@/components/atoms/AtomSwitch.vue"
import mixinObjectHelper from "@/mixins/mixinsObjectHelper"
import mixinsValidator from "@/mixins/mixinsValidator"
import MoleculeSubPackage from "@/components/molecules/globalSetting/dataManagement/MoleculeSubPackage.vue"

export default {
  name: "MoleculePackage",
  components: {
    AtomInput,
    AtomSwitch,
    MoleculeSubPackage,
  },
  mixins: [mixinsValidator, mixinObjectHelper],
  props: {
    packageItemBefore: {
      type: Object,
      required: false,
      default: () => {},
    },
    value: {
      type: Object,
      required: true,
    },
    isValidate: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasUpdatePermission: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["isPackageChangeNotSave"],
  computed: {
    packageItem: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },

    isError() {
      return this.isValidate && this.isEmptyString(this.packageItem.packageName)
    },

    isChange() {
      const isPackageChange =
        JSON.stringify(this.packageItemBefore) !==
        JSON.stringify(this.packageItem)

      this.$emit("isPackageChangeNotSave", isPackageChange)

      return isPackageChange
    },
  },

  methods: {
    addSubPackage(type, payload) {
      if (type === "Period") {
        this.packageItem.periods = payload
      } else if (type === "Service") {
        this.packageItem.details = payload
      } else if (type === "Add-On") {
        this.packageItem.options = payload
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card-padding {
  padding: 1.5rem;
}

.mt-60px {
  margin-top: 60px;
}

.gap-20px {
  gap: 20px;
}

.margin-bottom-22px {
  margin-bottom: 22px;
}

.margin-top-36px {
  margin-top: 36px;
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
  .w-md-60 {
    width: 60% !important;
  }
}
</style>
